import SideActionBase from '@/plugin/sideActions/sideActionBase';
import { Component } from 'vue-property-decorator';

@Component
export default class previewAttachmentActionComponent extends SideActionBase<any> {
    public get attachment() {
        return this.options.attachment;
    }
}
